export const filterLocations = (locations, locationType) => locations
    .map((location) => (location.type === locationType ? location : undefined))
    .filter((location) => location !== undefined);
